import { createRoot } from 'react-dom/client';
import { AuthProvider } from './lib/auth.jsx';
import App from './App.jsx';
import './styles.css';

// กัน "กล่องประ" (drag ghost) ตอนเผลอลากไอคอน/ข้อความในแอพ — ยกเลิก native element drag
// ทั้งแอพ; การลากไฟล์จากเครื่องมาวาง (dragover/drop) ไม่ได้รับผลกระทบ เพราะไม่ใช่ dragstart
document.addEventListener('dragstart', (e) => {
  if (!e.target?.closest?.('[draggable="true"]')) e.preventDefault();
});

createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <App/>
  </AuthProvider>
);
